module.exports = __webpack_public_path__ + "img/part-2-title.ae4a134b.png";